import { GifsSettings } from "../../views/GifsSettings";

export function Gifs() {
    return (
        <>
            <GifsSettings />
        </>
    );
}
